// @flow

import React from 'react';
export function BadgeAI() {
  return (
    <svg width="43" height="20" viewBox="0 0 43 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="43" height="20" rx="10" fill="#FF3000" fillOpacity="0.1" />
      <g clipPath="url(#clip0_20690_8014)">
        <path
          d="M13 4L14.2374 6.26263L16.5 7.5L14.2374 8.73737L13 11L11.7626 8.73737L9.5 7.5L11.7626 6.26263L13 4Z"
          fill="url(#paint0_linear_20690_8014)"
        />
        <path
          d="M18 9L18.884 10.616L20.5 11.5L18.884 12.384L18 14L17.116 12.384L15.5 11.5L17.116 10.616L18 9Z"
          fill="url(#paint1_linear_20690_8014)"
        />
        <path
          d="M13 13L13.5304 13.9696L14.5 14.5L13.5304 15.0304L13 16L12.4696 15.0304L11.5 14.5L12.4696 13.9696L13 13Z"
          fill="url(#paint2_linear_20690_8014)"
        />
      </g>
      <path
        d="M29.8613 14L29.2656 12.1982H26.6729L26.0674 14H24.793L27.293 6.9541H28.709L31.2139 14H29.8613ZM27.9326 8.29688L26.9658 11.2021H28.9727L28.0156 8.29688H27.9326ZM33.6846 14H32.4248V6.9541H33.6846V14Z"
        fill="url(#paint3_linear_20690_8014)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20690_8014"
          x1="9.81818"
          y1="6.04167"
          x2="14.4934"
          y2="10.8231"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#C830E1" />
          <stop offset="1" stop-color="#FE4A25" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_20690_8014"
          x1="15.7273"
          y1="10.4583"
          x2="19.0667"
          y2="13.8737"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#C830E1" />
          <stop offset="1" stop-color="#FE4A25" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_20690_8014"
          x1="11.6364"
          y1="13.875"
          x2="13.64"
          y2="15.9242"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#C830E1" />
          <stop offset="1" stop-color="#FE4A25" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_20690_8014"
          x1="24.5"
          y1="7.08333"
          x2="33.6335"
          y2="14.4228"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#C830E1" />
          <stop offset="1" stop-color="#FE4A25" />
        </linearGradient>
        <clipPath id="clip0_20690_8014">
          <rect width="12" height="12" fill="white" transform="translate(9 4)" />
        </clipPath>
      </defs>
    </svg>
  );
}
